import { makeVar } from '@apollo/client'
import { darkTheme, whiteTheme } from 'shared/styles/theme'

export const themeVar = makeVar<typeof whiteTheme | typeof darkTheme>(
  whiteTheme
)
